export const downloadTypeEnum = {
	PDF: 0,
	COOKIE_REPORT: 1,
	ADVANCED_TRACKERS: 2,
	SUB_RESOURCES: 3
}
